import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, map, tap } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { SettingModel } from '../../../core/models/setting.model'

interface SettingListResponse {
  data: SettingModel[]
}

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private http = inject(HttpClient)
  private apiUrl = environment.apiUrl

  private settings = new BehaviorSubject<SettingModel[]>([])
  private loading = new BehaviorSubject<boolean>(false)
  private saving = new BehaviorSubject<boolean>(false)

  public settings$ = this.settings.asObservable()
  public loading$ = this.loading.asObservable()
  public saving$ = this.saving.asObservable()

  getByType(settingType: string) {
    this.loading.next(true)
    return this.http
      .get<SettingListResponse | SettingModel[]>(`${this.apiUrl}/settings`)
      .pipe(
        map((res) => {
          const data: SettingModel[] = Array.isArray(res)
            ? res
            : ((res as SettingListResponse).data ?? [])
          return data.filter((s) => s.settingType === settingType)
        }),
        tap((filtered) => {
          this.settings.next(filtered)
          this.loading.next(false)
        })
      )
  }

  update(id: number, value: number) {
    this.saving.next(true)
    return this.http
      .put(`${this.apiUrl}/settings/${id}`, { value })
      .pipe(tap(() => this.saving.next(false)))
  }
}
